/* eslint-disable no-console */
import superagent from 'superagent';
import { MERCHANT_ID } from '../../config/constants';
import generateDigest from './crypto';
import HttpSignature from './HttpSignature';

function paramToString(param) {
  if (param === undefined || param == null) {
    return '';
  }
  if (param instanceof Date) {
    return param.toJSON();
  }
  return param.toString();
}

function normalizeParams(params) {
  const newParams = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const key in params) {
    // eslint-disable-next-line no-prototype-builtins
    if (params.hasOwnProperty(key) && params[key] !== undefined && params[key] != null) {
      const value = params[key];
      if (Array.isArray(value)) {
        newParams[key] = value;
      } else {
        newParams[key] = paramToString(value);
      }
    }
  }
  return newParams;
}

const processPost = (requestHost, endpoint, method, payload, callback) => {
  const merchantId = MERCHANT_ID;
  const resource = endpoint;
  const verb = method;
  const url = `https://${requestHost}${resource}`;

  const headerParams = {};
  const contentType = 'application/json';
  const acceptType = '*/*';

  const request = superagent(verb, url);

  const bodyParam = payload;

  const signature = HttpSignature(resource, method, payload);
  const date = new Date(Date.now()).toUTCString();

  let digest = generateDigest(payload);
  digest = `SHA-256=${digest}`;

  headerParams.digest = digest;
  headerParams['v-c-merchant-id'] = merchantId;
  headerParams['v-c-date'] = date;
  headerParams.signature = signature;

  request.set(normalizeParams(headerParams));

  request.timeout(60000);

  request.type(contentType);

  request.send(bodyParam);

  request.accept(acceptType);
  let returnObject = null;
  request.end((error, response) => {
    let data = response.body;
    if (
      data == null ||
      (typeof data === 'object' && typeof data.length === 'undefined' && !Object.keys(data).length)
    ) {
      // SuperAgent does not always produce a body; use the unparsed response as a fallback
      data = response.text;
    }

    let status = -1;
    if (response.status >= 200 && response.status <= 299) {
      status = 0;
    }
    returnObject = {
      request: {
        body: bodyParam
      },
      response: {
        body: data
      }
    };
    callback(error, data, returnObject, status);
  });
};

export default processPost;
